import { Col, Row } from "antd";
import {
  FaAddressBook,
  FaBox,
  FaClock,
  FaDotCircle,
  FaSync,
} from "react-icons/fa";
import StatisticsCard from "../../components/StatisticsCard";
import ChartCard from "../../components/ChartCard";
import {
  countryStats,
  countryStatsSecond,
} from "../../utils/helpers/constants";

const Statistics = () => {
  return (
    <>
      <Row gutter={[16, 10]}>
        <Col span={8}>
          <StatisticsCard
            icon={
              <FaAddressBook
                size={15}
                style={{ position: "relative", top: 2 }}
              />
            }
            value="86"
            label="عدد المستخدمين"
            iconBgColor="#74baff"
            iconColor="#74baff"
            titleColor="#74baff"
          />
        </Col>
        <Col span={8}>
          <StatisticsCard
            icon={
              <FaDotCircle size={15} style={{ position: "relative", top: 2 }} />
            }
            value="20"
            label="عدد النقاط"
            iconBgColor="#6c5ce7"
            iconColor="#6c5ce7"
            titleColor="#6c5ce7"
          />
        </Col>
        <Col span={8}>
          <StatisticsCard
            icon={<FaBox size={15} style={{ position: "relative", top: 2 }} />}
            value="86"
            label="اجمالي الطلبات"
            iconBgColor="#0984e3"
            iconColor="#0984e3"
            titleColor="#0984e3"
          />
        </Col>
        <Col span={8}>
          <StatisticsCard
            icon={<FaSync size={14} style={{ position: "relative", top: 2 }} />}
            value="6"
            label="طلبات قيد المعالجة"
            iconBgColor="#74baff"
            iconColor="#74baff"
            titleColor="#74baff"
          />
        </Col>
        <Col span={8}>
          <StatisticsCard
            icon={
              <FaClock size={14} style={{ position: "relative", top: 2 }} />
            }
            value="5.851"
            label="طلبات معلقة"
            iconBgColor="#fdcb6e"
            iconColor="#fdcb6e"
            titleColor="#fdcb6e"
          />
        </Col>
        <Col span={8}>
          <StatisticsCard
            icon={
              <FaClock size={14} style={{ position: "relative", top: 2 }} />
            }
            value="5.851"
            label="الطلبات المنفذة"
            iconBgColor="#00b894"
            iconColor="#00b894"
            titleColor="#00b894"
          />
        </Col>
      </Row>

      <Row gutter={[10, 12]} style={{ marginTop: "5px" }}>
        <Col span={12}>
          <ChartCard title="أعلى البلدان حسب النقاط" countries={countryStats} />
        </Col>

        <Col span={12}>
          <ChartCard
            title="أعلى البلدان حسب الطلبات"
            countries={countryStatsSecond}
          />
        </Col>

        <Col span={12}>
          <ChartCard
            title="أعلى 10 بلدان حسب المستخدمين"
            countries={countryStats}
          />
        </Col>
        <Col span={12}>
          <ChartCard title="تقارير المنتجات" countries={countryStatsSecond} />
        </Col>
      </Row>
    </>
  );
};

export default Statistics;
